import React, { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { Image } from 'semantic-ui-react';
import defaultUserAvatar from '../img/avatars/default-avatar.png';
import { SatCoreRegister } from '../SatCoreRegistry';

const Avatar = (props) => {
  const { userManager } = useContext(MobXProviderContext);
  const defaultAvatar = props.defaultImage ? props.defaultImage : defaultUserAvatar;
  const alt = userManager.displayName ? `User avatar for ${userManager.displayName}` : 'User avatar';

  return (
    <Image
      alt={alt}
      avatar
      className={props.className}
      onError={(i) => i.target.src = defaultAvatar}
      src={(props.fullProfileImageUrl === null) ? defaultAvatar : props.fullProfileImageUrl}
      tabIndex='-1' />
  );
};

export default Avatar;

SatCoreRegister('Avatar', Avatar);
